import {Loader2} from "lucide-react";

/**
 * Тот же язык, что и у «неизвестно сколько ждать, неизвестна форма контента»
 * в остальном приложении (см. StatusBadge в AnalysisHistoryPage.tsx) — не
 * скелет: скелет предполагает знание формы будущего контента, а здесь код
 * страницы ещё даже не загружен, знать нечего.
 */
function RouteLoaderSpinner() {
    return (
        <div className="text-center">
            <Loader2
                className="size-8 mx-auto mb-3 text-[var(--rla-ink-3)]"
                style={{animation: "spin 1s linear infinite"}}
                aria-hidden="true"
            />
            <p className="text-sm text-[var(--rla-ink-3)]">Загрузка...</p>
        </div>
    );
}

/**
 * Заглушка на время проверки сессии — общая для гардов роутов (GuestRoute,
 * CompanyRoute, ProtectedRoute), а также фолбэк по умолчанию для ленивых
 * страниц без нижней навигации (лендинг, регистрация, админка, кабинет
 * компаний, юридические документы).
 *
 * Раньше фон был красно-жёлтым градиентом с красной же окантовкой спиннера —
 * на холодной загрузке чанка это на долю секунды читалось как экран ошибки,
 * а не как загрузка (красный в системе зарезервирован под алярмы, см.
 * `--rla-alarm`). Теперь фон и спиннер — на нейтральных токенах приложения.
 */
export function RouteLoader() {
    return (
        <div className="size-full flex items-center justify-center bg-[var(--rla-bg)]">
            <RouteLoaderSpinner/>
        </div>
    );
}

/**
 * Suspense-фолбэк для ленивых ВКЛАДОК нижней навигации (Главная, Куда сходить,
 * Сообщения, Профиль).
 *
 * Шапка и нижняя капсула больше не часть фолбэка: они живут в TabShellLayout
 * (components/Main/TabShell.tsx) и переживают переходы, поэтому на время
 * холодной загрузки чанка заменяется только область контента. Раньше фолбэк
 * рисовал собственную копию каркаса, и каждая смена вкладки пересоздавала
 * шапку и таб-бар по два раза (страница -> загрузчик -> новая страница).
 */
export function TabRouteLoader() {
    return (
        <main className="relative z-10 flex flex-1 min-h-0 items-center justify-center bg-[var(--rla-bg)]">
            <RouteLoaderSpinner/>
        </main>
    );
}
